module.exports = __webpack_public_path__ + "static/media/driver_not_aval.d847d8cd.png";